import { ComponentType } from 'react'
import { TextHero } from 'components/TextHero'
import { AboutNav } from 'views/common/about-nav'
import { Experts } from './experts'
import { Team } from './team'

export const About: ComponentType = () => (
  <>
    <TextHero title="Conoce Mérida, Descubre Yucatán" subtitle="Conoce nuestra experiencia premier" />
    <AboutNav />
    {/*<Experts />*/}
    <Team />
  </>
)
